import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Moment } from "moment/moment";

export type SearchFormData = {
    startDate: Moment | null;
    endDate: Moment | null;
    regionId: number | undefined;
    curationId: number | undefined;
};

export type ComponentState = {
    showPaymentComponent: boolean;
    showBookedComponent: boolean;
    searchFormData: SearchFormData | undefined;
};

const initialState: ComponentState = {
    showPaymentComponent: false,
    showBookedComponent: false,
    searchFormData: undefined,
};

export const vanliferComponentsSlice = createSlice({
    name: "vanliferComponents",
    initialState,
    reducers: {
        setPaymentComponent: (state, { payload }: PayloadAction<boolean>) => {
            state.showPaymentComponent = payload;
        },
        setBookedComponent: (state, { payload }: PayloadAction<boolean>) => {
            state.showBookedComponent = payload;
        },
        resetTourComponentState: (state) => {
            state.showPaymentComponent = false;
            state.showBookedComponent = false;
        },
        setSearchFormData: (state, { payload }: PayloadAction<SearchFormData | undefined>) => {
            state.searchFormData = payload;
        },
    },
});

export const { setPaymentComponent, setBookedComponent, resetTourComponentState, setSearchFormData } =
    vanliferComponentsSlice.actions;

export const vanliferComponentsReducer = vanliferComponentsSlice.reducer;
